import { useHighlightText } from "../../hooks/useHighlightText";

const FooterIndicator = ({ fuente }: { fuente: string }) => {
    const { highlight } = useHighlightText();

    return (
        <div className='bg-brand-green-1 rounded-sm'>
            <div className='p-3 text-system-light-40 text-bmedium'>
                <p>Fuente: {highlight(fuente)}</p>
            </div>
        </div>
    )
}

export default FooterIndicator